import { render, staticRenderFns } from "./AssistantGroup.vue?vue&type=template&id=3fde7b20"
import script from "./AssistantGroup.vue?vue&type=script&lang=js"
export * from "./AssistantGroup.vue?vue&type=script&lang=js"
import style0 from "./AssistantGroup.vue?vue&type=style&index=0&id=3fde7b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports